import { alpha, useTheme } from '@mui/material';
import { Box } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';
import * as Preact from 'preact';
import { isSmallScreen } from './domain/theme/breakpoints';
import { WarningChange } from './icons/warningChange';
import { useTranslations } from './utils/TranslationsWrapper';
export var Component = function (p) {
    var t = useTranslations().t;
    var theme = useTheme();
    return (Preact.h(ListItemButton, { selected: p.selected, onClick: p.onClick, sx: {
            height: '44px',
            paddingX: '16px',
            backgroundColor: p.selected
                ? alpha(theme.palette.primary.main, 0.05)
                : 'transparent',
            borderRadius: '8px',
            border: '1px solid',
            borderColor: p.selected ? 'primary.main' : alpha('#000000', 0.08),
            '&:hover': isSmallScreen(theme)
                ? ''
                : {
                    borderColor: p.selected
                        ? 'primary.main'
                        : alpha(theme.palette.primary.main, 0.15),
                    backgroundColor: 'transparent',
                },
            justifyContent: 'space-between',
        } },
        Preact.h(Box, { sx: {
                display: 'flex',
                gap: '16px',
                alignItems: 'center',
            } },
            p.image || p.colour || p.hasThumbnailOffset ? (Preact.h(Box, { width: "37px", height: "26px", borderRadius: "5px", sx: { background: p.image || p.hasThumbnailOffset ?
                        "center / cover url('".concat(p.text === 'furniture.option.none' ? 'assets/cross.png' : p.image, "')") :
                        p.colour
                } })) : null,
            Preact.h(Typography, { variant: "body2" }, p.text === 'furniture.option.none' ? t(p.text) : p.text)),
        p.compatible === false && Preact.h(WarningChange, { opacity: "35%" })));
};
Component.displayName = 'SelectionButton';
